import React from 'react';
import { View, StyleSheet, TouchableOpacity, Platform, Text } from 'react-native';
import CS from '../../constants/Styles';
import { Button, BackgroundGradient, Loader, Alert } from '../../components';
import { FontAwesome5 } from '@expo/vector-icons';
import VerifyBusiness from './VerifyBusiness';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useHeaderHeight } from '@react-navigation/elements';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { useLinkTo } from '@react-navigation/native';


const VerifyBusinessScreen = ({ ...props }) => {
  const [loading, setLoading] = React.useState(false);
  const [businessIdPreview, setBusinessIdPreview] = React.useState(false);
  // const [acceptableIds, setAcceptableIds] = React.useState([]);
  const [alertOptions, setAlertOptions] = React.useState({});

  let businessIdRef = null;
  let scrollRef = React.useRef(null);

  const headerHeight = useHeaderHeight();
  const insets = useSafeAreaInsets();
  const linkTo = useLinkTo();

  React.useEffect(() => {
    checkSignUpProgress();
  }, []);

  const checkSignUpProgress = (route) => {
    if (!props.signUpProgress.AccountType) {
      linkTo('/login');
    }
  }

  // React.useEffect(() => {
  //   if(props.structure === 'Corporation'){
  //     setAcceptableIds([
  //       "Certificate of incorporation",
  //       "Certificate of corporate status",
  //       "Record that has to be filed annually under provincial securities legislation",
  //       "Published annual report signed by an audit firm",
  //       "Letter or notice of assessment from a municipal, provincial, territorial or federal government",
  //     ]);
  //   }else if(props.structure === 'Partnership'){
  //     setAcceptableIds([
  //       "A partnership agreement",
  //       "Articles of association",
  //       "Any other similar record that confirms the existence of the entity",
  //       "Letter or notice of assessment from a municipal, provincial, territorial or federal government",
  //     ]);
  //   } else if (props.structure === 'Sole Proprietorship'){
  //     setAcceptableIds([
  //       "Articles of association",
  //       "Any other similar record that confirms the existence of the entity",
  //       "Letter or notice of assessment from a municipal, provincial, territorial or federal government",
  //     ]);
  //   }
  // }, []);
  
  const checkIdentity = () => {
    console.log('checkIdentity outer: ', props.businessId);
    if (!props.businessId) {
      let buttonText = props.isContractor ? 'Continue' : 'Sign Up';
      console.log('buttonText: ', buttonText);
      // Alert.alert('Account Verification', `1 acceptable ID is required to verify your business. Please upload them before hitting "Continue"\n\nSelect "Do It Later" if you do not want, or are unable, to upload your ID. However, please note that your account will remain unverified and you will face restrictions until your account is verified.\n\nYou may upload identification anytime by modifying your profile.`);
      setAlertOptions({
        visible: true,
        title: 'Account Verification',
        message: `1 acceptable ID is required to verify your business. Please upload them before hitting "Continue"\n\nSelect "Do It Later" if you do not want, or are unable, to upload your ID. However, please note that your account will remain unverified and you will face restrictions until your account is verified.\n\nYou may upload identification anytime by modifying your profile.`,
      });
      return;
    }
    nextRoute();
  };
  const skipIdentity = () => {
    props.setBusinessId(null);
    nextRoute();
  };
  const nextRoute = async () => {
    props.completeStep('VerifyBusiness');
  }

  const goBack = () => {
    if (props.navigation.canGoBack()) {
      props.navigation.goBack();
    } else {
      linkTo('/signup/accounttype');
    }
  }

  return (
    <View style={CS.container}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      <KeyboardAwareScrollView ref={scrollRef} keyboardShouldPersistTaps='handled' extraHeight={headerHeight + 20} contentContainerStyle={[styles.innerContainer, { paddingTop: insets.top, paddingBottom: insets.bottom }]} style={styles.container}>
      {/* <ScrollView ref={scrollRef} style={styles.container} contentContainerStyle={styles.innerContainer}> */}
        <TouchableOpacity onPress={goBack} style={{ marginTop: 10, marginBottom: 20, justifyContent: 'center' }}>
          <FontAwesome5 name="arrow-left" size={24} color="white" style={{ position: 'absolute' }} />
          <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, { marginVertical: 0 }]}>Verify Business</Text>
        </TouchableOpacity>
        <VerifyBusiness {...props} businessIdPreview={businessIdPreview} setBusinessIdPreview={setBusinessIdPreview} scrollView={scrollRef} />

        {!businessIdPreview && (
          <View style={[CS.rowContainer, CS.buttons, styles.buttons]}>
            <View style={CS.buttonLeft}>
              <Button text='Do it Later' onPress={() => skipIdentity} color='blue' />
            </View>
            <View style={CS.buttonRight}>
              <Button text='Continue' onPress={() => checkIdentity} />
            </View>
          </View>
        )}

      </KeyboardAwareScrollView>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flex: 1,
    marginVertical: 10,
  },
  innerContainer: {
    width: '100%',
    // backgroundColor: 'blue',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    // justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
    flexGrow: 1,
    alignSelf: 'center',
  },
  buttons: {
    marginTop: 'auto',
  }
});

export default VerifyBusinessScreen;